import { Box, Chip, CircularProgress, Typography } from '@mui/material';
import { useDataProvider } from 'react-admin';
import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { Palette } from '@/themes/themeOverrides/Palette';
import { START_OF_ANALYTICS } from '@/components/analytics/PeriodFilters';

const TagList = ({ tagsData }) => (
    <Box
        sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            minWidth: '216px',
        }}
    >
        {tagsData.map(tag => (
            <Chip
                key={tag.id}
                label={tag.name}
                size='small'
                sx={{
                    backgroundColor: tag.categoryColor,
                    borderRadius: '4px',
                    color: Palette.black,
                }}
            />
        ))}
    </Box>
);

const EmptyList = () => (
    <Typography variant='body2' className='gray'>
        —
    </Typography>
);

export const CachedContractorTopTagsField = ({ record }) => {
    let tagsData = record?.topTags;

    if (!Array.isArray(tagsData) || tagsData.length === 0) return <EmptyList />;

    return <TagList tagsData={tagsData} />;
};

export const ContractorTopTagsField = ({ record }) => {
    const dataProvider = useDataProvider();

    const defaultFilters = {
        contractorId: record?.id,
        rankingType: 'mostPopular',
        periodStart: START_OF_ANALYTICS,
        periodEnd: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    };

    const {
        data: tagsData,
        isLoading,
        error,
    } = useQuery({
        queryKey: ['tag-ranking', { filter: defaultFilters }],
        queryFn: () => dataProvider.summary('analytic-products/tag-ranking', { filter: defaultFilters }),
        enabled: !!record?.id,
        select: response => {
            const tags = response.data?.data || [];
            return tags.slice(0, 5);
        },
    });

    if (isLoading) {
        return <CircularProgress size={16} />;
    }

    if (error || !tagsData || tagsData.length === 0) {
        return <EmptyList />;
    }

    return <TagList tagsData={tagsData} />;
};

ContractorTopTagsField.propTypes = {
    record: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }),
};
